import { render, staticRenderFns } from "./PrereqModal.vue?vue&type=template&id=63630f58&scoped=true&"
import script from "./PrereqModal.vue?vue&type=script&lang=js&"
export * from "./PrereqModal.vue?vue&type=script&lang=js&"
import style0 from "./PrereqModal.vue?vue&type=style&index=0&id=63630f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63630f58",
  null
  
)

export default component.exports